/** IANA timezone list + labels for integration settings (Google Calendar, GHL, etc.) */

export const getTimezoneOffset = (timeZone) => {
  try {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone,
      timeZoneName: "longOffset",
    });
    const parts = formatter.formatToParts(new Date());
    const offsetPart = parts.find((p) => p.type === "timeZoneName");
    if (offsetPart) {
      return offsetPart.value === "GMT" ? "GMT+00:00" : offsetPart.value;
    }
    return "GMT+00:00";
  } catch {
    return "GMT+00:00";
  }
};

export const buildTimezoneOptions = () => {
  let tzList = [];
  try {
    if (typeof Intl !== "undefined" && Intl.supportedValuesOf) {
      tzList = Intl.supportedValuesOf("timeZone");
    }
  } catch {
    // fallback below
  }

  if (tzList.length === 0) {
    tzList = [
      "Pacific/Midway", "Pacific/Pago_Pago", "Pacific/Honolulu", "America/Adak",
      "America/Anchorage", "America/Juneau", "America/Los_Angeles", "America/Vancouver",
      "America/Tijuana", "America/Denver", "America/Edmonton", "America/Phoenix",
      "America/Mazatlan", "America/Chicago", "America/Mexico_City", "America/Winnipeg",
      "America/Guatemala", "America/Costa_Rica", "America/New_York", "America/Toronto",
      "America/Bogota", "America/Lima", "America/Panama", "America/Halifax",
      "America/Caracas", "America/Santiago", "America/St_Johns", "America/Sao_Paulo",
      "America/Argentina/Buenos_Aires", "America/Montevideo", "Atlantic/South_Georgia",
      "Atlantic/Azores", "Atlantic/Cape_Verde", "Europe/London", "Europe/Dublin",
      "Europe/Lisbon", "Africa/Casablanca", "Africa/Accra", "Europe/Berlin",
      "Europe/Paris", "Europe/Rome", "Europe/Madrid", "Europe/Amsterdam",
      "Europe/Brussels", "Europe/Vienna", "Europe/Zurich", "Europe/Stockholm",
      "Europe/Oslo", "Europe/Copenhagen", "Europe/Warsaw", "Europe/Prague",
      "Europe/Budapest", "Africa/Lagos", "Africa/Cairo", "Europe/Helsinki",
      "Europe/Athens", "Europe/Bucharest", "Europe/Kyiv", "Africa/Johannesburg",
      "Europe/Istanbul", "Europe/Moscow", "Asia/Riyadh", "Africa/Nairobi",
      "Asia/Baghdad", "Asia/Tehran", "Asia/Dubai", "Asia/Baku", "Asia/Tbilisi",
      "Asia/Yerevan", "Asia/Kabul", "Asia/Karachi", "Asia/Tashkent",
      "Asia/Kolkata", "Asia/Colombo", "Asia/Kathmandu", "Asia/Dhaka",
      "Asia/Almaty", "Asia/Yangon", "Asia/Bangkok", "Asia/Jakarta",
      "Asia/Ho_Chi_Minh", "Asia/Singapore", "Asia/Shanghai", "Asia/Hong_Kong",
      "Asia/Taipei", "Asia/Kuala_Lumpur", "Australia/Perth", "Asia/Seoul",
      "Asia/Tokyo", "Australia/Adelaide", "Australia/Darwin", "Australia/Sydney",
      "Australia/Melbourne", "Australia/Brisbane", "Australia/Hobart",
      "Pacific/Guam", "Pacific/Port_Moresby", "Pacific/Noumea",
      "Pacific/Auckland", "Pacific/Fiji", "Pacific/Tongatapu",
      "Pacific/Apia", "Pacific/Kiritimati",
    ];
  }

  return tzList
    .map((tz) => {
      const offset = getTimezoneOffset(tz);
      return { value: tz, label: `(${offset}) ${tz.replace(/_/g, " ")}`, offset };
    })
    .sort((a, b) => {
      const parseOffset = (o) => {
        const match = o.match(/GMT([+-])(\d{2}):(\d{2})/);
        if (!match) return 0;
        return (match[1] === "+" ? 1 : -1) * (parseInt(match[2], 10) * 60 + parseInt(match[3], 10));
      };
      const diff = parseOffset(a.offset) - parseOffset(b.offset);
      return diff !== 0 ? diff : a.value.localeCompare(b.value);
    });
};

export const TIMEZONE_OPTIONS = buildTimezoneOptions();

export const getDetectedTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    return "";
  }
};
